// extracted by mini-css-extract-plugin
export default {"wrapper":"tu","subscription":"uu","select_item":"vu","is_selected":"wu","otb":"xu","radio":"yu","first_row":"zu","prices":"Au","italic":"Bu","info_wrapper":"Cu","first_month":"Eu","separator":"Fu","checkmark":"Gu","bullets":"Hu","bullet":"Iu","checkmarkText":"Ju","button":"Ku","discountBadge":"Lu"};
    if(module.hot) {
      // 1715632474970
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  